import { render } from "./VLoaderPacman.vue?vue&type=template&id=f6b817d0"
const script = {}

import "./VLoaderPacman.vue?vue&type=style&index=0&id=f6b817d0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__